import {
    WIZARD_INITIALIZED,
    SET_WIZARD_NUM_OF_STEPS,
    UPDATE_WIZARD_STEP,
    WIZARD_STARTED,
    WIZARD_STOPPED,
    WIZARD_STEP_UPDATED,
    WIZARD_PREV,
    WIZARD_NEXT,
    WIZARD_FIRST,
    WIZARD_LAST,
    WIZARD_ON_FINISH,
    WIZARD_RESET_FINISH,
    WIZARD_STEP_SELECTED,
    WIZARD_STEP_ENABLED,
    WIZARD_STEP_DISABLED,
    WIZARD_STEPS_UPDATED
} from "../Constants";

export function initialize() {
    return {
        type: WIZARD_INITIALIZED,
        payload: true
    };
}

export function setNumOfSteps(steps) {
    return {
        type: SET_WIZARD_NUM_OF_STEPS,
        payload: steps
    };
}

export function updateCurrentStep(step) {
    return {
        type: UPDATE_WIZARD_STEP,
        payload: step
    };
}



export function init(name, wizard) {
    return {
        type: WIZARD_INITIALIZED,
        payload: { name, wizard }
    };
}

export function start(name) {
    return {
        type: WIZARD_STARTED,
        payload: name
    };
}

export function stop(name) {
    return {
        type: WIZARD_STOPPED,
        payload: name
    };
}

export function goTo(name, number) {
    return {
        type: WIZARD_STEP_UPDATED,
        payload: { name, number }
    };
}

export function goPrev(name) {
    return {
        type: WIZARD_PREV,
        payload: name
    };
}

export function goNext(name) {
    return {
        type: WIZARD_NEXT,
        payload: name
    };
}

export function goFirst(name) {
    return {
        type: WIZARD_FIRST,
        payload: name
    };
}

export function goLast(name) {
    return {
        type: WIZARD_LAST,
        payload: name
    };
}

export function onFinish(name) {
    return {
        type: WIZARD_ON_FINISH,
        payload: name
    };
}

export function resetFinish(name) {
    return {
        type: WIZARD_RESET_FINISH,
        payload: name
    };
}

export function onStepClick(name, step) {
    return {
        type: WIZARD_STEP_SELECTED,
        payload: { name, step }
    };
}

export function enableStep(name, step) {
    return {
        type: WIZARD_STEP_ENABLED,
        payload: { name, step }
    };
}

export function disableStep(name, step) {
    return {
        type: WIZARD_STEP_DISABLED,
        payload: { name, step }
    };
}

export function updateSteps(name, steps) {
    return {
        type: WIZARD_STEPS_UPDATED,
        payload: { name, steps }
    };
}